import {
  DefaultFetchError,
  FetchCreate, FetchDelete,
  FetchGet,
  FetchGetId,
  FetchSuccess,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchCreate, useFetchDelete,
  useFetchGet,
  useFetchGetId, useFetchUpdate,
} from '../fetch';

// eslint-disable-next-line import/prefer-default-export
export enum SubjectType {
  SUGGESTION = 'suggestion',
  FEEDBACK = 'feedback',
  COMPLAINT = 'complaint',
  BUG = 'bug',
  REPORT = 'report',
  OTHER = 'other',
  NEW_CATEGORY = 'new category',
  NEW_SUBCATEGORY = 'new subcategory',
  EXPECTED_TIP = 'expected tip',
}

export interface Tikets {
  email: string;
  type: SubjectType;
  description: string;
}

export const useTiketsCreate = (): FetchCreate<FetchSuccess, DefaultFetchError, Tikets> => (
  useFetchCreate('tickets', { autoStart: false, startStateLoading: false })
);
export const useTiketsCreateByGuest = (): FetchCreate<FetchSuccess, DefaultFetchError, Tikets> => (
  useFetchCreate('tickets/by-guest', { autoStart: false, startStateLoading: false, authorization: false })
);
